import { Bridge } from "./bridge";
import { BaseStore, createAtomStore } from "@deputy-ai/common/jotai";
import { atom } from "jotai";
import { useEffect } from "react";

export enum Pages {
  HOME,
  CHAT,
}

export class WebchatStore extends BaseStore {
  visible = atom(false);
  styleOverride = atom("");

  bridge = atom<Bridge>(new Bridge(this));

  page = atom<Pages>(Pages.HOME);

  unreadMessageCount = atom(0);

  setStyleOverride(style: string) {
    this.set(this.styleOverride, style);
  }

  setVisible(visible: boolean) {
    this.set(this.visible, visible);
  }

  setPage(page: Pages) {
    this.set(this.page, page);
  }

  setUnreadMessageCount(count: number) {
    this.set(this.unreadMessageCount, count);
  }
}

export const { useWebchatStore, WebchatProvider } =
  createAtomStore<WebchatStore>("Webchat");

export const useObserveToggle = () => {
  const {
    use: { bridge, visible },
  } = useWebchatStore();

  useEffect(() => {
    if (visible) {
      bridge?.toggle(visible, false);
    } else {
      setTimeout(() => {
        bridge?.toggle(visible, false);
      }, 150);
    }
  }, [visible, bridge]);
};
